import { NgModule } from '@angular/core';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { PieceSelectMarketRenderComponent } from './render/piece-select-market-render.component';
import { SharedModule } from 'shared/shared.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { TranslatePipeModule } from 'extensions/oy/pipes/translate.pipe.module';
import { AnalyticsEventDirectiveModule } from 'idt-analytics-api/directives/analytics-events-directive.module';

export const pieceSelectMarketCmsModuleEntryComponents = [
  PieceSelectMarketRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    TranslatePipeModule,
    AnalyticsEventDirectiveModule
  ],
  providers: [RenderStateService],
  declarations: pieceSelectMarketCmsModuleEntryComponents,
  entryComponents: pieceSelectMarketCmsModuleEntryComponents
})
export class PieceSelectMarketRenderModule {}

export default pieceSelectMarketCmsModuleEntryComponents;
